



































































































































































import Vue from 'vue';
import axios from 'axios';

class ExpectedClass {
  ID = 0;
  IDPlaces = 0;
  IDTrainings = 0;
  documentNumber = '';
  documentCountry = '';
  name = '';
  ob = '';
}

export default Vue.extend({
  name: 'ExpectedView',

  data: () => ({
    expected: [new ExpectedClass()],
    newData: [new ExpectedClass()],
    newRecord: new ExpectedClass(),
    expectedSelected: [],
    filterPlaces: 0,
    filterTrainings: 0,
    filterOB: [],
    fullscreenEdit: false,
    modalDelete: false,
    places: [],
    trainings: [],
    countries: [],
    ob: [],
    tableData: [],
    headers: [
      { text: 'Školení', value: 'trainingName', width: '20%' },
      { text: 'Lokace', value: 'placeName', width: '20%' },
      { text: 'Jméno', value: 'name', width: '20%' },
      { text: 'Číslo dokumentu', value: 'documentNumber', width: '15%' },
      { text: 'Stát', value: 'documentCountry', width: '10%' },
      { text: 'ob', value: 'ob', width: '15%' },
    ],
    addHeaders: [
      { text: 'name', value: 'name' },
      { text: 'documentNumber', value: 'documentNumber' },
      { text: 'documentCountry', value: 'documentCountry' },
      { text: 'ob', value: 'ob' },
    ],
  }),
  mounted() {
    this.dataLoad();
    this.placesLoad();
    this.trainingsLoad();
    this.countriesLoad();
    this.obLoad();
  },
  methods: {
    addDialogOpen() {
      this.newData = [];
      this.newRecord.IDPlaces = this.filterPlaces;
      this.newRecord.IDTrainings = this.filterTrainings;
      this.fullscreenEdit = true;
    },
    appendRecord() {
      this.checkBlur().then(async () => {
        this.newData.push({ ...this.newRecord });
        this.newRecord.name = '';
        this.newRecord.documentNumber = '';
      });
    },
    dataLoad() {
      axios
        .get('/api/v1/expected', {
          params: {
            IDPlaces: this.filterPlaces,
            IDTrainings: this.filterTrainings,
            OB: this.filterOB,
          },
        })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          console.log('dbError', err);
        });
    },
    dataSave() {
      axios
        .post('/api/v1/expected', this.newData)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataDelete() {
      axios
        .post('/api/v1/expecteddelmulti', this.expectedSelected)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.expectedSelected = [];
      this.modalDelete = false;
    },
    placesLoad() {
      axios
        .get('/api/v1/place', { params: { IDTrainings: this.filterTrainings } })
        .then((response) => {
          this.places = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    trainingsLoad() {
      axios
        .get('/api/v1/training', { params: { IDPlaces: this.filterPlaces } })
        .then((response) => {
          this.trainings = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    countriesLoad() {
      axios
        .get('/api/v1/country')
        .then((response) => {
          this.countries = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    obLoad() {
      axios
        .get('/api/v1/expectedob')
        .then((response) => {
          this.ob = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    checkBlur() {
      return new Promise((resolve) => {
        (this.$refs.expectedob as HTMLElement).blur();
        resolve();
      });
    },
  },
});
